@if (showAboutThisPage) {
  <div class="onboarding-page-overlay"></div>
}

<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage"
      [title]="'Checklists'"
      [showLinkIcon]="true"
      [linkIcon]="'add-circle'"
      (linkAction)="goToAddToDoList()"
      [disabledLinkAction]="showAboutThisPage" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [ngClass]="{'flex-content': windowService.isDesktopRes}">

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
      <div class="wrappable-container">
        <tidy-text
          [title]="'Checklists'" />
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/img/search-header.svg'"
            class="header-search" />
        </form>
        <tidy-small-button
          [text]="'Filter'"
          [image]="'assets/img/filter-white.svg'"
          [matMenuTriggerFor]="menu"
          [matMenuTriggerDisabled]="showAboutThisPage"
          [matMenuTriggerData]="{closeDisabled: true}" />
        <tidy-small-button
          [text]="'Defaults'"
          [image]="'assets/img/settings-white.svg'"
          (buttonClick)="goToDefaultSettingsPage()" />
        <tidy-small-button
          [text]="'Add Checklist'"
          [image]="'assets/img/add-button-white.svg'"
          (buttonClick)="goToAddToDoList()" />
        <tidy-image
          [src]="'assets/img/download_csv.svg'"
          class="desktop-header-icon secondary-text-icon"
          (action)="exportCSV()"/>
        @for (chip of chips; track chip) {
          <ion-chip class="filter-chip">
            @if (chip.icon) {
              <mat-icon
                class="chip-icon"
                [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
            }
            <ion-label>{{ chip.name | titlecase | translate }}</ion-label>
            <ion-icon name="close-circle" (click)="removeChip(chip)" />
          </ion-chip>
        }
      </div>
      <div class="non-wrappable-right-aligned-container">
        @if (showLoadingSpinner) {
          <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
        }
        <automations-preview-button
          [tag]="'checklist'" />
      </div>
    </tidy-desktop-header>
  <mat-menu #menu="matMenu" class="filter-menu">
    @if (!showAboutThisPage && !showAddInspectionsOnboarding) {
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
            <mat-checkbox
              class="checkbox"
              [checked]="getNodeChecked(node)"
              (click)="$event.stopPropagation()"
              (change)="checkNode(node, $event)">
              {{ node.name | titlecase | translate }}
            </mat-checkbox>
          </button>
        </mat-tree-node>
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding>
          <button
            class="node-button-padding"
            mat-menu-item
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            {{ node.name | titlecase | translate }}
          </button>
        </mat-tree-node>
      </mat-tree>
    }
  </mat-menu>
  }

  @if (!windowService.isDesktopRes) {
    @if (!loaded) {
      <div style="width: 100%">
        <ion-skeleton-text
          animated="true"
          style="height: 75px; border-radius: 6px" />
      </div>
      <div style="width: 100%; padding-top: 1rem;">
        <ion-skeleton-text
          animated="true"
          style="height: 200px; border-radius: 6px" />
      </div>
      <div style="width: 100%;">
        <ion-skeleton-text
          animated="true"
          style="height: 200px; border-radius: 6px" />
      </div>
    }
    @if (loaded && rows?.length > 0) {
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    }
    @if (loaded) {
      @for (row of currentRows; track row) {
        <tidy-card>
          <tidy-card-button (action)="goToToDoList({element: row})">
            <tidy-row>
              <tidy-text
                [header]="row['Name'].value"
                [translate]="false" />
            </tidy-row>
            @if (row['Description'].value) {
              <tidy-row>
                <tidy-text
                  [body]="row['Description'].value"
                  [translate]="false" />
              </tidy-row>
            }
            @if (row['Remote Inspection'].icon) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="row['Remote Inspection'].icon"
                  style="width: 16px; height: 16px; margin-right: 5px;" />
                <tidy-text
                  [helper]="row['Remote Inspection'].truncate"
                  [translate]="false" />
              </tidy-row>
            }
          </tidy-card-button>
        </tidy-card>
      }
      @if (currentRows?.length === 0 && !isSearching) {
        <tidy-alert>
          <tidy-text [body]="'No checklists created'" />
        </tidy-alert>
      }
      @if (currentRows?.length === 0 && isSearching) {
        <tidy-alert>
          <tidy-text [body]="'No results'" />
        </tidy-alert>
      }
    }
  }

  <!-- Skeleton table while loading — rows float in with the entrance cascade;
       the real table below then replaces it in place, instantly (skipEntrance). -->
  @if (windowService.isDesktopRes && !loaded) {
    <tidy-table
      [skeletonLoading]="true"
      [columnslabels]="headers" />
  }

  @if (windowService.isDesktopRes && loaded) {
    <tidy-table
      #tidyTable
      [dataSource]="currentRows"
      [displayedColumns]="headers"
      [columnslabels]="headers"
      [allRowIsClickable]="true"
      [rowsToShow]="25"
      [showColumnLines]="false"
      (sortChange)="sortChanged($event)"
      (cellClick)="goToToDoList($event)"
      (pageChange)="pageChange($event)"
      [infiniteScroll]="true"
      [totalRows]="totalRows"
      [skipEntrance]="true"
      [blockSorting]="true" />
    @if (currentRows?.length === 0 && isSearching) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="'No results'" />
        </tidy-row>
      </tidy-alert>
    }
  }

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />


@if (showAboutThisPage) {
  <tidy-about-this-page
    [page]="'checklists'"
    (dismissed)="dismissAboutThisPage()" />
}